//haya
import React from "react";
import { Grid, Accordion, Pagination } from "semantic-ui-react";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Table from "react-bootstrap/Table";
import {
  Message,
  Icon,
  Segment,
  Header,
  Button,
  Divider,
  Input,
  Modal,
} from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";

//import Modal from "react-modal";

// import "react-phone-input-2/dist/style.css";
import { event } from "jquery";
import { API_BASE_URL } from "../utils/endpoints";
const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

class JobsHistory extends React.Component {
  state = { activeIndex: 0 };
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      totalpage: "1",
      activePage: 1,
      searchTotalPae: "1",
      searchActivePage: 1,
      searchWord: "",
      modalIsOpen: false,
      detailsData: [],
      detailsTotalpage: "1",
      detailsActivePage: 1,

      subAdminId: "",
      jobId: "",

      number: "",
      date: "",
      senderId: "",
      isLoading: false,
    };
  }

  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      document.querySelector(".darked_color").style =
        "text-align:right;width: 20%;white-space: pre;";

      document.querySelector(".ui.pagination.menu").style =
        "float: left !important; margin-left: 4% !important;";
      document.querySelector(".main_contact").style = "margin-right: 1%;";

      document.querySelector(".fixed_contact").style =
        "margin-right: 0% !important;";

      document.querySelector(".pagination").style = "display:block";
    }
  }

  getJobHistory = () => {
    if (
      this.state.number != "" &&
      this.state.date != "" &&
      this.state.date != null &&
      this.state.senderId != ""
    ) {
      var body = {
        number: this.state.number,
        date: this.state.date,
        senderID: this.state.senderId,
      };

      this.setState({
        isLoading: true,
      });

      var ip = window.location.origin;
      var s2 = "localhost:3000";
      var apiBaseUrl;

      var token = reactLocalStorage.get("accessToken");

      if (ip.includes(s2)) {
        apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/history`;
      } else {
        apiBaseUrl = window.location.origin + "/core/user/rest/jobs/history";
      }
      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, body, { headers: headers }).then((res) => {
        if (res.status === 200) {
          if (res.data.status === "success") {
            this.setState({
                isLoading: true
            })

            var ip = API_BASE_URL;
            var s2 = "localhost:3000";
            var apiBaseUrl;

            var token = reactLocalStorage.get('accessToken');

            if (ip.includes(s2)) {
                apiBaseUrl = API_BASE_URL + `/core/user/rest/jobs/history`;
            }
            else {
                apiBaseUrl = API_BASE_URL + "/core/user/rest/jobs/history"
            }
            var headers = { 'Content-Type': 'application/json', 'token': token }
            axios.post(apiBaseUrl, body, { headers: headers })
                .then(res => {
                    if (res.status === 200) {

                        if (res.data.status === "success") {
                            this.setState({
                                data: res.data.result,
                                isLoading: false
                            })

                        } else {
                            this.setState({
                                isLoading: false
                            })
                            toast({
                                type: "error",
                                title: i18n.t("error.label"),
                                description: res.data.result.ErrorDiscreption,
                                animation: "bounce",
                                time: 5000
                            });
                        }
                    } else {
                        this.setState({
                            isLoading: false
                        })
                        toast({
                            type: 'error',
                            title: i18n.t('error.label'),
                            description: i18n.t('Something_wrong.label'),
                            animation: 'bounce',
                            time: 5000,

                        });

                    }

                })
        }
        else {
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: res.data.result.ErrorDiscreption,
              animation: "bounce",
              time: 5000,
            });
          }
        } else {
          this.setState({
            isLoading: false,
          });
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      });
    } else {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("Please_fill_all_fields.label"),
        animation: "bounce",
        time: 5000,
      });
    }
  };

  render() {
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_contact">
            <div className="main_contact ">
              <Grid columns={2} divided className="fixed_contact">
                <Grid.Row stretched className="fixed_header disable_z">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style darked_color">
                        {this.state.isArabic ? (
                          <img
                            alt=""
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            alt=""
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />

                <Divider horizontal>
                  <Header as="h2">
                    <Icon name="wpforms" size="tini" color="black" />
                    {this.state.isArabic ? "تاريخ الوظائف" : "Jobs History"}
                  </Header>
                </Divider>
                <br />

                <div className="" style={{ display: "flex", float: "right" }}>
                  <br />
                  <Input
                    size="small"
                    color="black"
                    placeholder={i18n.t("Number.label")}
                    onChange={(e) => {
                      this.setState({
                        number: e.target.value,
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <Input
                    size="small"
                    color="black"
                    placeholder={i18n.t("Sender_ID.label")}
                    onChange={(event) =>
                      this.setState({
                        senderId: event.target.value,
                      })
                    }
                    style={{ float: "right" }}
                  />

                  <Input
                    type="date"
                    size="small"
                    color="black"
                    placeholder={i18n.t("date.label")}
                    onChange={(event) =>
                      this.setState({
                        date: event.target.value,
                      })
                    }
                    style={{ float: "right" }}
                  />

                  <Button
                    floated="right"
                    disabled={this.state.isLoading}
                    color="grey"
                    basic
                    size="small"
                    onClick={() => {
                      this.getJobHistory();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isLoading === false
                      ? i18n.t("get_history.label")
                      : i18n.t("please_wait.label")}
                  </Button>
                  <br />
                </div>

                <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {i18n.t("date.label")}{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {i18n.t("Content.label")}{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {" "}
                        {i18n.t("Status.label")}{" "}
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        {this.state.data.date ? this.state.data.date : ""}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {this.state.data.content ? this.state.data.content : ""}
                      </td>

                      <td style={{ textAlign: "center" }}>
                        {this.state.data.status ? this.state.data.status : ""}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Segment>
            </div>

            {/* //////////////////////////////////////////////////////////////////////////////////////////////// */}
          </div>
        </div>

        <SemanticToastContainer />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(JobsHistory);
